import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { toast } from "react-toastify";
import { getNomeAmigavel } from "./relatorios";
import { RemoveRelatorioAcesso } from "../../../../data/services";

const RemoverAcessoModal = ({ login, relatorios, onClose, onSuccess }) => {
  const [selected, setSelected] = useState("");

  const handleRemove = async () => {
    if (!selected) {
      toast.warning("Selecione um relatório para remover!");
      return;
    }

    try {
      const res = await RemoveRelatorioAcesso(login, selected);

      if (res.data.success || res.status === 200) {
        toast.success("Acesso removido com sucesso!");
        onSuccess();
        onClose();
      } else {
        toast.error(res.data.message || "Erro ao remover acesso.");
      }
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Erro ao remover o acesso."
      );
    }
  };

  return (
    <Overlay>
      <ModalContainer>
        <Title>Remover Acesso</Title>
        <Info>
          <strong>Matrícula:</strong> {login}
        </Info>

        <Label>Selecione o relatório a remover</Label>
        <Select value={selected} onChange={(e) => setSelected(e.target.value)}>
          <option value="">Selecione...</option>
          {relatorios.map((nomeArquivo) => (
              <option key={nomeArquivo} value={nomeArquivo}>
                {getNomeAmigavel(nomeArquivo)}
              </option>
            ))}
        </Select>

        <ButtonRow>
          <CancelButton onClick={onClose}>Cancelar</CancelButton>
          <RemoveButton onClick={handleRemove}>Remover</RemoveButton>
        </ButtonRow>
      </ModalContainer>
    </Overlay>
  );
};

export default RemoverAcessoModal;

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  animation: ${fadeIn} 0.3s ease;
`;

const ModalContainer = styled.div`
  background: #fff;
  border-radius: 14px;
  padding: 28px;
  width: 420px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  animation: ${fadeIn} 0.25s ease;
`;

const Title = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  color: #e60303;
  margin-bottom: 1.2rem;
`;

const Info = styled.p`
  font-size: 1.4rem;
  color: #333;
  margin-bottom: 1.2rem;
`;

const Label = styled.label`
  display: block;
  font-size: 1.3rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
`;

const Select = styled.select`
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 1.4rem;
  font-size: 1.3rem;
  &:focus {
    outline: none;
    border-color: #f29b9b;
    box-shadow: 0 0 0 2px rgba(242, 155, 155, 0.3);
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const CancelButton = styled.button`
  background: #f2f2f2;
  border: none;
  color: #444;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    background: #e0e0e0;
  }
`;

const RemoveButton = styled.button`
  background: linear-gradient(135deg, #f59a9a, #f47c7c);
  border: none;
  color: #5a1414;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background: linear-gradient(135deg, #f27070, #e96363);
  }
`;
